/** @jsxImportSource @emotion/react */

import React from 'react';
import styled from 'styled-components';
import TextBlock from '@component/common/block/text-block';
import * as color from '@constant/color';
import * as size from '@constant/size';
import { ETheme } from '@datatype/type';
import { v4 as uuid4 } from 'uuid';

export interface IStep {
  label: string;
  isCheck: boolean;
  isCurrent?: boolean;
  isFuture?: boolean;
  isBeforeSignup?: boolean;
}

interface IProps {
  theme?: ETheme;
  items: IStep[];
  width?: string;
}

const Wrapper = styled.div<{ $width?: string }>`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
  width: ${(props) => props.$width || 'fit-content'};
`;

const DayItemWrapper = styled.div`
  position: relative;
  display: flex;
  flex: 1;
`;

// 초록색 테두리 원
const Check = styled.div`
  position: absolute;
  top: -2px;
  right: -2px;
  width: 8px;
  height: 8px;
  border: 2px solid ${color.GREEN_4};
  border-radius: 50%;
  background-color: transparent;
`;

// 빨간색 X
const Uncheck = styled.div`
  position: absolute;
  top: -2px;
  right: -2px;
  width: 8px;
  height: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  color: ${color.RED_3};
  line-height: 1;
`;

const WeekStamp: React.FC<IProps> = ({ items, width }) => {
  return (
    <Wrapper $width={width}>
      {items.map((item) => (
        <DayItemWrapper key={uuid4()}>
          <TextBlock
            text={item.label}
            design={{
              text: { size: 'small', color: color.BLACK_2, bold: item.isCurrent },
              box: {
                padding: '3px 0px',
                width: '100%',
                // backgroundColor: item.isCurrent ? color.YELLOW_5 : 'transparent',
                backgroundColor: 'transparent',
                border: true,
                borderWidth: '1px',
                borderColor: item.isCurrent ? color.YELLOW_1 : color.GRAY_3,
                borderRadius: '5px',
                alignX: 'center',
                alignY: 'center',
              },
            }}
          />
          {/* 미래 날짜, 가입 이전 날짜가 아닌 경우에만 상태 표시 */}
          {/* 오늘(isCurrent)이면서 미출석이면 표시하지 않음 */}
          {!item.isFuture &&
            !item.isBeforeSignup &&
            (item.isCheck ? <Check /> : !item.isCurrent && <Uncheck>×</Uncheck>)}
        </DayItemWrapper>
      ))}
    </Wrapper>
  );
};

export default WeekStamp;
